import { css } from '@adornis/chemistry/directives/css.js';
import type { FormController } from '@adornis/forms/x-form-controller.js';
import type { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import type { Student } from '@chancenwerk/master-data-management/users/entities/Student.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import ImageBergSide from '../assets/logo_chancenreise_quer.svg';
import AbschlussLogo from './../assets/chancenabschluss_logo.png';
import ImageFamily from './../assets/Einfuhrung_rund_um_die_Lernkaskade-small-min.png';
import { AnmeldungPageRegistrationBase } from './anmeldung-component-formular-base.js';

/**
 * @customElement anmeldung-component-formular-finished
 */
@customElement('anmeldung-component-formular-finished')
export class AnmeldungPageRegistrationLangSelect extends AnmeldungPageRegistrationBase {
  @property({ attribute: false }) form!: FormController<Student>;
  @property({ attribute: false }) translation!: TranslationController<any>;
  @property({ attribute: 'school-level' }) schoolLevel: 'us' | 'os' | 'graduation' = 'us';

  private _getText() {
    switch (this.schoolLevel) {
      case 'us':
        return 'Vielen Dank für die Anmeldung zur Lernkaskade von Chancenwerk e.V.';
      case 'os':
        return 'Vielen Dank für deine Anmeldung zur CHANCENreise von Chancenwerk e.V.';
      case 'graduation':
        return html`Vielen Dank für die Anmeldung zum CHANCENabschluss von Chancenwerk e.V. <br />
          Vor dem Kursstart werden wir uns mit allen wichtigen Informationen bei dir melden! (Checke bitte auch immer
          wieder deinen SPAM-Ordner)`;
    }
  }

  private _getImage() {
    switch (this.schoolLevel) {
      case 'us':
        return ImageFamily;
      case 'os':
        return ImageBergSide;
      case 'graduation':
        return AbschlussLogo;
    }
  }

  override render() {
    return html` <cr-flex center crossaxis-center space="xl">
      <cr-text
        ${css({
          textAlign: 'center',
          fontSize: '24px',
          lineHeight: '2',
        })}
      >
        ${this._getText()}
      </cr-text>

      <cr-flex crossaxis-center space="lg">
        <cr-text ${css({ textAlign: 'center', fontSize: '24px' })}>
          ${this.schoolLevel === 'os' || this.schoolLevel === 'graduation'
            ? ''
            : 'Wir haben Ihnen eine Bestätigungsmail geschickt.'}
        </cr-text>
        <cr-text ${css({ textAlign: 'center', fontSize: '20px' })}>
          ${this.schoolLevel === 'os' || this.schoolLevel === 'graduation'
            ? ''
            : '(Checken Sie bitte auch in Ihrem SPAM-Ordner, ob die Bestätigungsmail dort angekommen ist.)'}
        </cr-text>
      </cr-flex>

      <cr-image disabled .value=${this._getImage()} mode="width" ${css({ width: '80%' })}> </cr-image>
    </cr-flex>`;
  }
}
